import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  filterOptions: false,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setSearch(state, action) {
      state.search = action.payload;
    },
    setFilter(state, action) {
      state.filterOptions = action.payload;
    },
  },
});

export const { setSearch, setFilter } = filterSlice.actions;
export default filterSlice.reducer;
